import React from 'react';

const JoinTheClub: React.FC = () => {
  return (
    <section className="mx-auto px-4 md:px-10 lg:px-32 w-full bg-[#192842] pt-20 pb-20">
      <div className="">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          {/* Text Content - Left Side */}
          <div className="space-y-8">
            <h2 className="text-[25px] md:text-[40px] lg:text-[40px] font-[700] leading-[40px] text-[#fff] mb-7 lg:text-left">
            Join Our Elite Community
            </h2>
            <p className="text-[16px] md:text-[20px] lg:text-[20px] text-[#fff] leading-[29px] font-[400] mb-4 last:mb-0 text-justify">
            The Wealthy Miner is more than a research platform—it's a community of investors committed to mastering junior mining through shared intelligence. With limited founding memberships, now is the time to join and access Rob's expert analysis. Start free to explore mining stocks news and mining market trends, or become a founding member for real-time stock picks and insider strategies.</p>
            <a href="https://the-wealthy-miner.mn.co/" target="_blank" rel="noopener noreferrer" className="inline-block w-full bg-transparent border-2 border-white text-[#fff] lg:px-20 py-2.5 rounded-lg font-semibold lg:text-[20px] text-[16px] hover:bg-white hover:text-[#1A2A44] transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50 text-center">
            BECOME A PREMIUM MEMBER
                        </a>
          </div>

          {/* Phone Mockups - Right Side */}
          <div className="flex justify-center lg:justify-end">
            <img 
              src="/images/phones.webp" 
              alt="Three overlapping phone mockups showing The Wealthy Miner app content" 
              className="w-full max-w-4xl h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default JoinTheClub;
